/** 文档权限申请/设置 API（REQ-03） */
import http, { request } from './http';

export type DocPermissionType = 'EDIT' | 'DOWNLOAD';

export async function applyDocumentPermission(
  projectId: number,
  body: { objectKey: string; fileName?: string; permissionType: DocPermissionType },
) {
  return request(http.post(`/projects/${projectId}/document-permissions/apply`, body));
}

export async function decideDocumentPermission(
  projectId: number,
  requestId: number,
  approved: boolean,
) {
  return request(http.post(`/projects/${projectId}/document-permissions/requests/${requestId}/decide`, { approved }));
}

export async function revokeDocumentPermission(projectId: number, requestId: number) {
  return request(http.post(`/projects/${projectId}/document-permissions/requests/${requestId}/revoke`));
}

export interface DocumentPermissionCheck {
  canEdit: boolean;
  canDownload: boolean;
  inherentAccess: boolean;
  downloadRequestStatus: string | null;
  editRequestStatus: string | null;
  lastDownloadRequestStatus: string | null;
  lastEditRequestStatus: string | null;
}

export interface DocumentPermissionPendingRequest {
  id: number;
  projectId: number;
  objectKey: string;
  fileName?: string | null;
  applicantUserId: number;
  applicantName?: string | null;
  permissionType: DocPermissionType;
  status: string;
  createdAt?: string | null;
}

export async function checkDocumentPermissions(projectId: number, objectKey: string): Promise<DocumentPermissionCheck> {
  const res = await request<{
    success?: boolean;
    data?: Partial<DocumentPermissionCheck>;
  }>(
    http.get(`/projects/${projectId}/document-permissions/check`, { params: { objectKey } }),
  );
  const data = (res as any)?.data ?? res;
  return {
    canEdit: !!data?.canEdit,
    canDownload: !!data?.canDownload,
    inherentAccess: !!data?.inherentAccess,
    downloadRequestStatus: (data?.downloadRequestStatus as string | null | undefined) ?? null,
    editRequestStatus: (data?.editRequestStatus as string | null | undefined) ?? null,
    lastDownloadRequestStatus: (data?.lastDownloadRequestStatus as string | null | undefined) ?? null,
    lastEditRequestStatus: (data?.lastEditRequestStatus as string | null | undefined) ?? null,
  };
}

export async function listPendingDocumentPermissionRequests(
  projectId: number,
): Promise<DocumentPermissionPendingRequest[]> {
  const res = await request(http.get(`/projects/${projectId}/document-permissions/requests/pending`));
  const data = (res as any)?.data ?? res;
  return Array.isArray(data) ? data : [];
}

export async function listDocumentPermissionGrants(projectId: number, objectKey: string) {
  const res = await request(http.get(`/projects/${projectId}/document-permissions`, { params: { objectKey } }));
  const data = (res as any)?.data ?? res;
  return Array.isArray(data) ? data : [];
}

export async function setDocumentPermissionGrants(
  projectId: number,
  body: { objectKey: string; userId: number; canEdit: boolean; canDownload: boolean },
) {
  return request(http.put(`/projects/${projectId}/document-permissions`, body));
}
